import { gql } from "@apollo/client";

export const QUERY_GET_NOTIFICATION_CRON_CONFIG = gql`
  query GetNotificationCronConfig {
    getNotificationCronConfig {
      id
      cronIntervalHours
      lastRunAt
    }
  }
`;

export const QUERY_GET_NOTIFICATION_RECIPIENTS = gql`
  query GetNotificationRecipients($licenseId: String!) {
    getNotificationRecipients(licenseId: $licenseId) {
      id
      licenseId
      product
      extraRecipients
    }
  }
`;
